// extracted by mini-css-extract-plugin
module.exports = {"wr_map_page":"_38YgSQRZPLzSa-s0D-5ds"};